import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {FC, useEffect, useState} from 'react';
import {mobileOnlyLinaria} from '../../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../constants/typography';
import {
  ContentPopper,
  ContentPopperProps,
} from '../../../atoms/ContentPopper/ContentPopper';
import {SecondaryContentPopperButton} from '../../../atoms/ContentPopper/ContentPopperButtons/ContentPopperButtons';
import {Text} from '../../../atoms/Text/Text';
import {usePriceLegalInfoPopup} from './usePriceLegalInfoPopup';

interface PriceLegalInfoPopupProps {
  PriceLegalInfoLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const PriceLegalInfoPopup: FC<PriceLegalInfoPopupProps> = ({
  PriceLegalInfoLayoutComponent,
}) => {
  const {t} = useTranslation();
  const {cancel, isOpen, priceLegalInfoPopupContent} = usePriceLegalInfoPopup();
  const [content, setContent] = useState<{title?: string; body?: string}>();

  useEffect(() => {
    if (isOpen) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setContent(priceLegalInfoPopupContent);
    }
  }, [isOpen]);

  return (
    <StyledContentPopper
      LayoutComponent={PriceLegalInfoLayoutComponent}
      onClose={cancel}
      open={isOpen}
      renderInPortal
      headerContent={
        <TitleWrapper>
          <LegalInfoHeader size="px20" weight="mediumHeavy">
            {content?.title}
          </LegalInfoHeader>
        </TitleWrapper>
      }
      bodyContent={
        <LegalRichText
          dangerouslySetInnerHTML={{
            __html: content?.body ?? '',
          }}
        />
      }
      footerContent={
        <SecondaryContentPopperButton label={t('Close')} onClick={cancel} />
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)`
  #modalContent {
    width: min(600px, 100%);
  }
`;

const LegalInfoHeader = styled(Text)`
  line-height: 1.2;
`;

const TitleWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

const LegalRichText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${mobileOnlyLinaria(`
    &, p, a {
      font-size: ${FONT_SIZES.px14};
      font-weight: ${FONT_WEIGHTS.mediumBold};
      line-height: 1.4;
    }
    
    a {
      font-weight: ${FONT_WEIGHTS.mediumHeavy};
      text-decoration: underline;
      text-underline-offset: 3px;
    
      &::after {
        content: '';
      }
    }
  `)}
`;
